import { Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import AppContainer from "../../components/containers/AppContainer";
import Loader from "../../components/loader";
import NavigationDrawer from "../../components/navigationDrawer";
import SnackbarAlert from "../../components/snackbar";
import RichTextEditorPage from "../../components/textEditor";
import { getSettings, updateSettings } from "../../services/Auth";
import CustomBar from "../../components/customBar";

const Setting = () => {
  const snackRef = useRef(null);
  const [settings, setSettings] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setIsLoading(true);
    try {
      const res = await getSettings();
      if (res.status === 200) {
        setSettings(res.data.data);
      } else {
        snackRef.current?.isOpenSnack("error", res.data.message);
      }
    } catch (err) {
      console.error(err);
      snackRef.current?.isOpenSnack("error", "Failed to load settings");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeTax = (field, value) => {
    console.log(`Field: ${field}, Value:`, value);
    setSettings((prev) => ({ ...prev, [field]: value }));
  };

  const handleUpdateAll = async () => {
    if (!settings) return;
    setIsLoading(true);
    try {
      const payload = {
        privacyPolicy: settings.privacyPolicy,
        termsAndCondition: settings.termsAndCondition,
      };
      const res = await updateSettings(settings._id, payload);
      const type = res.data.status === "success" ? "success" : "error";
      fetchSettings();
      snackRef.current?.isOpenSnack(type, res.data.message);
    } catch (err) {
      console.error(err);
      snackRef.current?.isOpenSnack("error", "Update failed");
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading || !settings) {
    return <Loader isVisible={true} />;
  }

  return (
    <NavigationDrawer>
      <CustomBar title={"SETTINGS"} />
      <AppContainer styleProps={{ mt: 3 }}>
        <RichTextEditorPage
          title="Privacy Policy"
          value={settings.privacyPolicy}
          onChange={(newVal) => handleChangeTax("privacyPolicy", newVal)}
        />
      </AppContainer>

      <AppContainer styleProps={{ mt: 3 }}>
        <RichTextEditorPage
          title="Terms and Conditions"
          value={settings.termsAndCondition}
          onChange={(newVal) => handleChangeTax("termsAndCondition", newVal)}
        />
      </AppContainer>

      <AppContainer styleProps={{ mt: 4, textAlign: "center" }}>
        <Button
          variant="contained"
          fullWidth
          onClick={handleUpdateAll}
          disabled={isLoading}
          sx={{
            py: 1.5,
            fontSize: 16,
            fontWeight: "bold",
            borderRadius: 2,
            backgroundColor: "#003B95",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
            transition: "transform 0.2s",
            "&:hover": {
              transform: "scale(1.02)",
              boxShadow: "0px 6px 18px rgba(0,0,0,0.2)",
            },
          }}
        >
          {isLoading ? "Updating..." : "UPDATE SETTINGS"}
        </Button>
      </AppContainer>

      <SnackbarAlert ref={snackRef} />
    </NavigationDrawer>
  );
};

export default Setting;
